export {productsBySlugQuery} from './productsBySlug.groq'
